import { render, staticRenderFns } from "./salesteamlead-vue.vue?vue&type=template&id=dafc662a&scoped=true&"
import script from "./salesteamlead-vue.vue?vue&type=script&lang=js&"
export * from "./salesteamlead-vue.vue?vue&type=script&lang=js&"
import style0 from "./salesteamlead-vue.vue?vue&type=style&index=0&id=dafc662a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafc662a",
  null
  
)

export default component.exports